import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { toQS } from 'lib/query-params';

export default function Breadcrumb({ items, query }) {
  if (!items.length) return null;
  return (
    <nav aria-label="breadcrumb" role="navigation">
      <ol className="breadcrumb">
        {items.map((item, index) => (
          <li
            className={`breadcrumb-item ${item.active && 'active'}`}
            key={index}>
            {item.active ? (
              item.name
            ) : (
              <Link route={`${item.href}?${toQS(query)}`}>{item.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

Breadcrumb.propTypes = {
  items: PropTypes.array.isRequired,
  query: PropTypes.object
};

Breadcrumb.defaultProps = {
  items: [],
  query: {}
};
